import React from 'react';
import { PropTypes } from 'prop-types';
import TextInput from '@atoms/TextInput';
import SelectCountries from '@molecules/SelectCountries';
import SelectStates from '@molecules/SelectStates';

const FormFieldsAddress = ({
    isRequired = false,
    fieldNameCountry,
    fieldNameAddress1,
    fieldNameAddress2,
    fieldNameAddress3,
    fieldNameCity,
    fieldNameState,
    fieldNameZip,
}) => (
    <>
        <SelectCountries name={fieldNameCountry} label="Select Your Country" required={isRequired} />
        <TextInput label="Address Line 1" name={fieldNameAddress1} type="text" required={isRequired} />
        <TextInput label="Address Line 2" name={fieldNameAddress2} type="text" />
        <TextInput label="Address Line 3" name={fieldNameAddress3} type="text" />
        <TextInput label="City" name={fieldNameCity} type="text" required={isRequired} />
        <SelectStates name={fieldNameState} countryFieldName={fieldNameCountry} required={isRequired} />
        <TextInput label="Zip / Mail Code" name={fieldNameZip} type="text" />
    </>
);

FormFieldsAddress.propTypes = {
    isRequired: PropTypes.bool,
    fieldNameCountry: PropTypes.string,
    fieldNameAddress1: PropTypes.string,
    fieldNameAddress2: PropTypes.string,
    fieldNameAddress3: PropTypes.string,
    fieldNameCity: PropTypes.string,
    fieldNameState: PropTypes.string,
    fieldNameZip: PropTypes.string,
};

export default FormFieldsAddress;
